import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { AppComponent } from './app.component'
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthGuard } from './laas/auth-guard.service';

import { DigireportComponent } from './digireport/digireport.component';
 
const routes: Routes = [
  { path: '', loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule) },
  { path: 'landing', loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule) },
  { path: 'laas/:id', loadChildren: () => import('./laas/laas.module').then(m => m.LaasModule) },
  // { path: 'admin', loadChildren: './admin/admin.module#AdminModule', canActivate: [AdminAuthGuard] },
  // { path: 'digi-report/:id', component: DigireportComponent}, 
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [AuthGuard, ],
})
export class AppRoutingModule { }
